const lightTheme = {
  id: 'light', // identifier of theme

  bgLightest: '#ffffff',
  bgSecondLightest: '#fafafa',
  bgThirdLightest: '#f6f6f6',
  bgFourthLightest: '#f0f0f0',
  bgLightestInverse: '#f6f6f6',
  bgDarkestInverse: '#e9e9e9',
  hoverBg: '#f0f0f0',
  hoverBgLightestInverse: '#f0f0f0',
  hoverBgDarkestInverse: '#f0f0f0',
  borderColor: '#e5e5e5',
  primary: '#884ffc',
  primaryHover: '#6d3fca',
  primary75: '#9c75f8',
  primary50: '#F2F1F2',
  secondary: '#e9ecef',
  success: '#3ecf8e',
  danger: '#dc3545',
  warning: '#ffc107',
  info: '#0dcaf0',
  light: '#e9ecef',
  lightInverse: '#1d2024',
  dark: '#1d2024',
  darkInverse: '#fff',
  darkInverseRgba: 'rgba(0, 0, 0,.0235)',

  sidebarTogglerOpenBg: '#e9ecef',
  sidebarTogglerCloseBg: '#fff',
  sidebarTogglerBorderColor: 'rgba(0, 0, 0, 0.125)',
  sidebarTogglerShadowColor: 'rgba(0, 0, 0, 0.01)',
  textGreyTinted: '#5f697a',
  textGreyTintedMediumLighter: '#6b778a',
  textGreyTintedDarker: '#495057',
  textGreyTintedDarkest: '#30353b',
  textGreyTintedInverse: '#b3bac5',
  textHeaderLight: '#90979e',
  textGreyTintedLighter: '#7c8593',
  textGreyTintedLighterInverse: '#7c8593',
  menuItemBg: '#f0f0f0',
  menuItemSecondaryBg: '#f0f0f0',
  workspaceMenuItemBg: '#f0f0f0',
  skeletonBaseColor: '#eee',
  skeletonHighlightColor: '#f5f5f5',
  modalSplitNavBg: '#fafafa',
  modalBg: '#fff',
  mark: '#f5f5c4',
  white: '#fff',
  white90: '#eee',
  white80: '#ccc',
  white90Inverse: '#495057',
  black: '#000',
  blackRgb: '0,0,0',
  placeholderColor: '#d5d9de',
  timeColor: '#6f7a8f',
  tableRowHover: 'rgba(0,0,0,.045)',
  tableThColor: '#363c42',
  avatarBg: '#dedede',
  avatarColor: '#fff',
  avatarBorderColor: '#fff',
  bsBodyColor: '#1d2024',
  bsRedColor: '#dc3545',
  bsInfoColor: '#0dcaf0',
  bsWarningColor: '#ffc107',
  bsSuccessColor: '#3ecf8e',
  bsSuccessMutedColor: '#2b91af',
  bsBtnSecondary: '#e9ecef',
  bsWarningRgb: '255,193,7',
  bsHeadingColor: '#1d2024',
  switchBg: '#D3D3D3',
  orange: '#ffa172',
  orangeBright: '#F5A623',
  splitPaneLight: 'rgba(255, 255, 255, 0)',
  splitPaneDark: 'rgba(0, 0, 0, 0.5)',
  splitPaneColor: '#626d78',
  dropZoneBg: 'rgba(0,0,0,.035)',
  dropZoneBorderColor: 'rgba(0,0,0,.125)',
  boardBg: '#f6f6f6',
  taskBg: '#fff',
  attachmentBg: '#f0f0f0',
  hoverBgLight: '#f0f0f0',
  roadmapBg: '#ffffff',
  roadmapItemEven: '#fff',
  roadmapItemOdd: '#f6f6f6',
  roadmapItemHover: '#f0f0f0',
  taskNoStatusColor: '#a0a0a0',
  taskNoStatusBorder: '#ccc',
  taskNoTypeColor: '#86919c',
  sprintColor: '#2abcb6',
  linkColor: '#007bff',
  linkHoverColor: '#0062cc',
  epicBadgeBg: 'hsl(252.70000000000005,76.5%,94.1%)',
  epicBadgeColor: 'hsl(252.70000000000005,76.5%,29.2%)',
  commentHeader: '#f6f6f6',
  fileEditorTab: '#fff',
  progressBarBg: '#e5e5e5',
  reportAreaFill: '#ccc',
  pipelineConnector: '#adb5bd',
  pipelineConnectorDot: '#c4aafa',
  pipelineConnectorDotBorder: '#f9f9f9',
  pipelineLogColor: '#adb5bd',
  documentToolbarButtonDisabled: '#a5bac9',
  documentToolbarColor: '#6b7380',
  boxShadow: 'rgba(0, 0, 0, 0.07)',
  logHistogramColor: '#74797d',
  logHistogramBg: '#fafafa',
  logHistogramStrokeColor: '#bbb',
  logLineColor: '#525a69',
  logOrangeColor: '#e59100',
  logHoverBg: '#e0e0e0',
  roadmapBarBg: 'rgb(240,240,240)',
  tabNavHoverBorderColor: '#b8b8b8',
  textDocumentGroup: '#495057',
  textDocumentSection: '#515b66',
  textDocumentSectionHeader: '#373c42',
  textWorkspaceItem: '#495057',
  textWorkspaceItemLight: '#838891',
  activeNavButtonColor: '#e0e0e0',
  bgChatMessage: '#f6f6f6',
  bgChatMessageLoader: 'rgba(246, 246, 246, .65)',
  loaderDot: '#cfcfcf',
  loaderDotFaded: '#e5e5e5'
}

const darkTheme = {
  id: 'dark', // identifier of theme

  bgLightest: '#1d2024',
  bgSecondLightest: '#23272b',
  bgThirdLightest: '#1d2024',
  bgFourthLightest: '#1d2024',
  bgLightestInverse: '#2d3238',
  bgDarkestInverse: '#1d2024',
  hoverBg: '#2d3238',
  hoverBgLightestInverse: '#23272b',
  hoverBgDarkestInverse: '#1d2024',
  borderColor: '#383d42',
  primary: '#884ffc',
  primaryHover: '#6d3fca',
  primary75: '#9c75f8',
  primary50: '#F2F1F2',
  secondary: '#2d3238',
  success: '#3ecf8e',
  danger: '#dc3545',
  warning: '#ffc107',
  info: '#0dcaf0',
  light: '#e9ecef',
  lightInverse: '#e9ecef',
  dark: '#1d2024',
  darkInverse: '#121517',
  darkInverseRgba: 'rgba(18, 21, 23,.8)',

  sidebarTogglerOpenBg: '#2d3238',
  sidebarTogglerCloseBg: '#1d2024',
  sidebarTogglerBorderColor: 'rgba(255, 255, 255, 0.125)',
  sidebarTogglerShadowColor: 'rgba(255, 255, 255, 0.01)',
  textGreyTinted: '#adb5bd',
  textGreyTintedMediumLighter: '#adb5bd',
  textGreyTintedDarker: '#adb5bd',
  textGreyTintedDarkest: '#adb5bd',
  textGreyTintedInverse: '#adb5bd',
  textHeaderLight: '#90979e',
  textGreyTintedLighter: '#7c8593',
  textGreyTintedLighterInverse: '#adb5bd',
  menuItemBg: '#1d2024',
  menuItemSecondaryBg: '#23272b',
  workspaceMenuItemBg: '#23272b',
  skeletonBaseColor: '#353b40',
  skeletonHighlightColor: '#434a52',
  modalSplitNavBg: '#23272b',
  modalBg: '#1d2024',
  mark: '#f5f5c4',
  white: '#fff',
  white90: '#eee',
  white80: '#ccc',
  white90Inverse: '#e2e2e2',
  black: '#000',
  blackRgb: '0,0,0',
  placeholderColor: '#626973',
  timeColor: '#90979e',
  tableRowHover: 'rgba(255,255,255,.045)',
  tableThColor: '#adb5bd',
  avatarBg: '#2d3238',
  avatarColor: '#7c8593',
  avatarBorderColor: '#495057',
  bsBodyColor: '#adb5bd',
  bsRedColor: '#dc3545',
  bsInfoColor: '#0dcaf0',
  bsWarningColor: '#ffc107',
  bsWarningRgb: '255,193,7',
  bsSuccessColor: '#3ecf8e',
  bsSuccessMutedColor: '#2b91af',
  bsBtnSecondary: '#6c757d',
  bsHeadingColor: '#efefef',
  switchBg: '#2d3238',
  orange: '#ffa172',
  orangeBright: '#F5A623',
  splitPaneLight: 'rgba(0, 0, 0, 0)',
  splitPaneDark: 'rgba(255, 255, 255, 0.5)',
  splitPaneColor: '#adb5bd',
  dropZoneBg: 'rgba(255,255,255,.035)',
  dropZoneBorderColor: 'rgba(255,255,255,.125)',
  boardBg: '#2d3238',
  taskBg: '#1d2024',
  attachmentBg: '#2d3238',
  hoverBgLight: '#2d3238',
  roadmapBg: '#1d2024',
  roadmapItemEven: '#1d2024',
  roadmapItemOdd: '#23272b',
  roadmapItemHover: '#1f2226',
  taskNoStatusColor: '#6c757d',
  taskNoStatusBorder: '#86919c',
  taskNoTypeColor: '#86919c',
  sprintColor: '#2abcb6',
  linkColor: '#58a6ff',
  linkHoverColor: '#4b8edb',
  epicBadgeBg: '#2d3238',
  epicBadgeColor: '#adb5bd',
  commentHeader: '#23272b',
  fileEditorTab: '#1d2024',
  progressBarBg: '#495057',
  reportAreaFill: '#1d2024',
  pipelineConnector: '#adb5bd',
  pipelineConnectorDot: '#c4aafa',
  pipelineConnectorDotBorder: '#2d3238',
  pipelineLogColor: '#adb5bd',
  documentToolbarButtonDisabled: '#5d6870',
  documentToolbarColor: '#adb5bd',
  boxShadow: 'rgba(255, 255, 255, 0.005)',
  logHistogramColor: '#91989e',
  logHistogramBg: '#23272b',
  logHistogramStrokeColor: '#545b63',
  logLineColor: '#adb5bd',
  logOrangeColor: '#FFC45E',
  logHoverBg: '#2d3238',
  roadmapBarBg: 'rgb(40, 43, 46)',
  tabNavHoverBorderColor: '#7c8593',
  textDocumentGroup: '#a2a9b3',
  textDocumentSection: '#818a99',
  textDocumentSectionHeader: '#c3cdd6',
  textWorkspaceItem: '#a2a9b3',
  textWorkspaceItemLight: '#6d7278',
  activeNavButtonColor: '#23272b',
  bgChatMessage: '#23272b',
  bgChatMessageLoader: 'rgba(35, 39, 43, .85)',
  loaderDot: '#353b40',
  loaderDotFaded: '#545c6b'
}

const lightTerminalTheme = {
  background: '#ffffff',
  cursor: '#333333',
  foreground: '#333333',
  selectionBackground: '#00000040',

  // ansi escape code colors
  black: '#000000',
  red: '#cd3131',
  green: '#00bc00',
  yellow: '#949800',
  blue: '#0451a5',
  magenta: '#bc05bc',
  cyan: '#0598bc',
  white: '#555555',
  brightBlack: '#686868',
  brightRed: '#cd3131',
  brightGreen: '#00bc00',
  brightYellow: '#949800',
  brightBlue: '#0451a5',
  brightMagenta: '#bc05bc',
  brightCyan: '#a5a5a5'
}

const darkTerminalTheme = {
  background: '#121517',
  cursor: '#eff0eb',
  foreground: '#eff0eb',
  selectionBackground: '#97979b33',

  // ansi escape code colors
  black: '#000000',
  red: '#ff5c57',
  green: '#5af78e',
  yellow: '#f3f99d',
  blue: '#57c7ff',
  magenta: '#ff6ac1',
  cyan: '#9aedfe',
  white: '#f1f1f0',
  brightBlack: '#686868',
  brightRed: '#ff5c57',
  brightGreen: '#5af78e',
  brightYellow: '#f3f99d',
  brightBlue: '#57c7ff',
  brightMagenta: '#ff6ac1',
  brightCyan: '#9aedfe',
  brightWhite: '#f1f1f0'
}

const getTheme = theme => {
  switch (theme) {
    case 'light':
      return lightTheme
    case 'dark':
      return darkTheme
    default:
      return darkTheme
  }
}

const getTerminalTheme = theme => {
  switch (theme) {
    case 'light':
      return lightTerminalTheme
    case 'dark':
      return darkTerminalTheme
    default:
      return darkTheme
  }
}
const getMonacoTheme = theme => {
  switch (theme) {
    case 'light':
      return { theme: 'vs', background: getTheme(theme).bgLightest, dropdownBackground: getTheme(theme).bgLightest }
    case 'dark':
      return { theme: 'vs-dark', background: getTheme(theme).bgLightest, dropdownBackground: getTheme(theme).bgSecondLightest }
    default:
      return { theme: 'vs-dark', background: getTheme(theme).bgLightest, dropdownBackground: getTheme(theme).bgSecondLightest }
  }
}

const getSelectTheme = theme => {
  const selectLightTheme = {
    primary: lightTheme.primary,
    primary25: '#f6f6f6',
    primary50: '#f0f0f0',
    neutral0: '#FFFFFF',
    neutral5: '#fafafa',
    neutral10: '#E0E0E0',
    neutral25: '#f6f6f6',
    neutral30: '#e5e5e5',
    neutral20: '#ced4da',
    neutral40: '#1d2024',
    neutral50: '#1d2024',
    neutral60: '#1d2024',
    neutral80: '#1d2024',
    boxShadow: '0 0.5rem 1rem rgba(0, 0, 0, 0.15)',
    borderColor: '#e5e5e5'
  }

  const selectDarkTheme = {
    primary: darkTheme.primary,
    primary25: '#2d3238',
    primary50: '#23272b',
    neutral0: '#1d2024',
    neutral5: '#23272b',
    neutral10: '#23272b',
    neutral25: '#2d3238',
    neutral20: '#495057',
    neutral30: '#495057',
    neutral40: '#adb5bd',
    neutral50: '#adb5bd',
    neutral60: '#adb5bd',
    neutral80: '#adb5bd',
    boxShadow: '0 0.5rem 1rem rgba(0, 0, 0, 0.15)',
    borderColor: '#495057'
  }

  switch (theme) {
    case 'light':
      return selectLightTheme
    case 'dark':
      return selectDarkTheme
    default:
      return selectDarkTheme
  }
}

const getBase16Theme = theme => {
  const base16LightTheme = {
    base00: 'transparent',
    base01: '#495057',
    base02: '#495057',
    base03: '#495057',
    base04: '#495057',
    base05: '#495057',
    base06: '#495057',
    base07: '#495057',
    base08: '#495057',
    base09: '#495057',
    base0A: '#495057',
    base0B: '#495057',
    base0C: '#495057',
    base0D: '#495057',
    base0E: '#495057',
    base0F: '#495057'
  }

  const base16DarkTheme = {
    base00: 'transparent',
    base01: '#adb5bd',
    base02: '#adb5bd',
    base03: '#adb5bd',
    base04: '#adb5bd',
    base05: '#adb5bd',
    base06: '#adb5bd',
    base07: '#adb5bd',
    base08: '#adb5bd',
    base09: '#adb5bd',
    base0A: '#adb5bd',
    base0B: '#adb5bd',
    base0C: '#adb5bd',
    base0D: '#adb5bd',
    base0E: '#adb5bd',
    base0F: '#adb5bd'
  }

  switch (theme) {
    case 'light':
      return base16LightTheme
    case 'dark':
      return base16DarkTheme
    default:
      return base16DarkTheme
  }
}
const baseColors = ['#0dcaf0', '#20c997', '#ffa172', '#884ffc', '#ffc107']
const getBaseColors = index => baseColors[index]
  
export { getTheme, getSelectTheme, getMonacoTheme, getBase16Theme, getBaseColors, getTerminalTheme }
